// Since the JS Infinity value doesn't serialize nicely into JSON,
// we use an arbitrarily large value as our "INFINITY".
// Gross, since this "infinite" number is totally finite,
// but necessary due to JSON...
export const INFINITY = 1e100;
